<template>
  <div id="divProcessing" style="display:none;">
    <div>Processing Please wait...</div>
  </div>
</template>
<script>
export default {
  props: {
    isVisible: { type: Boolean, default: false },
  },
  mounted() {
    let ttt;
    let divProcessing = document.getElementById("divProcessing");
    if (divProcessing) {
      var observer = new MutationObserver(function (mutations) {
        window.setTimeout(function () {
          divProcessing.style.display = "none";
        }, 100);
      });
      observer.observe(document, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
      });
    }
  },
  watch: {
    isVisible(newValue, oldValue) {
      if (newValue) {
        let divProcessing = document.getElementById("divProcessing");
        if (divProcessing) {
          divProcessing.style.display = "";
        }
      }
    },
  },
};
</script>
<style>
#divProcessing {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 200%;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/Processing.vue